import * as React from "react";

export const TrashIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={170.667}
        height={170.667}
        viewBox="0 0 128 128"
        {...props}
    >
        <g fill="currentColor">
            <path
                d="M48.5 2.5C46.5 4.4 46 5.9 46 10v5H32.8c-9.7.1-13.8.4-15.1 1.4C15.6 18 12 26.9 12 30.5c0 3.2 3.3 6.5 6.5 6.5 1.4 0 2.5.3 2.5.7 0 .5 1.6 19.1 3.4 41.5 3.6 44 3.7 44.2 9.6 47.3 2.6 1.4 7.3 1.5 32 1.3l28.9-.3 2.9-2.8c1.7-1.6 3.3-4.3 3.6-6 .6-3.1 6.6-75.7 6.6-79.4 0-1.3 1.1-2.2 3.2-2.8 4.7-1.4 5.7-4.9 3.4-12.1-2.9-9.1-3.4-9.4-19.1-9.4H82v-5c0-4.1-.5-5.6-2.5-7.5C77.2.1 76.6 0 64 0S50.8.1 48.5 2.5m25.5 9V15H54V8h20zm32.9 13.6c.6 1.8 1.1 3.4 1.1 3.5 0 .2-19.8.4-44 .4s-44-.2-44-.4c0-.1.5-1.7 1.1-3.5l1.1-3.1h83.6zm-6.5 17.1c-.3 2.9-1.8 21.1-3.4 40.5-1.5 19.3-3.1 35.6-3.4 36.2-1.1 1.7-56 1.5-57.4-.2-.9-1.1-7.2-69.8-7.2-78.6V37h71.9z"/>
            <path
                d="M39.5 42.7c-1.2 1.2-1.4 3.1-1 8.7.3 3.9 1.2 19.7 2.1 35 .8 15.4 1.7 28.3 2 28.8.9 1.5 5.4.8 6.1-.9.6-1.6-2.4-67.3-3.3-70.4-.6-2.3-4.1-3-5.9-1.2m23.5-1c-.8.3-1.8 1.1-2.2 1.7-1.4 2-.9 70.1.4 71.4 1.7 1.7 5.5 1.5 6.2-.4.3-.9.6-17 .6-35.9 0-29.9-.2-34.6-1.6-35.9-.8-.9-1.6-1.6-1.7-1.5-.1 0-.9.3-1.7.6m21.2 1.1c-1.8 1.6-2.1 4.5-3.7 36.4-.9 19.1-1.4 35.1-1 35.7.8 1.4 5.2 1.4 6 0 .9-1.4 4.6-69.5 3.9-71.3-.9-2.3-3.2-2.6-5.2-.8"/>
        </g>
    </svg>
);

